// EmailJS Configuration
// Replace these with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  // EmailJS credentials
  PUBLIC_KEY: '_5Bd06H99FOapknzX',
  SERVICE_ID: 'service_b912lu9',
  TEMPLATE_ID: 'template_iobli0p',
  
  // Email settings
  TO_EMAIL: 'support@lordvservices.com',
  FROM_NAME: 'Lord V Services Contact Form'
}

// Instructions for setup:
// 1. Go to https://www.emailjs.com/ and create an account
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create an email template with these variables:
//    - {{from_name}} - Customer's name
//    - {{from_email}} - Customer's email
//    - {{phone}} - Customer's phone
//    - {{company}} - Customer's company
//    - {{service}} - Selected service
//    - {{message}} - Customer's message
// 4. Get your Public Key, Service ID, and Template ID
// 5. Replace the values above with your actual credentials
